import { Suspense, useEffect, useState } from "react";
import Loader from "../components/Loader/Loader";
import FooterAdmin from "../components/Footers/FooterAdmin";
import { useNavigate, useParams } from "react-router-dom";
import { getOrderTrackingData } from "../services/order";
import { toast } from "sonner";
import moment from "moment";
import {
  CheckCircle,
  Circle,
  Clock,
  Home,
  Menu,
  Package,
  PackageCheck,
  Truck,
  X,
} from "lucide-react";
import { message, Modal } from "antd";
import { decryptToken } from "../utils/global-function";

function getOrderActions(status) {
  const finalStates = [
    "Delivered",
    "delivered",
    "Cancelled",
    "cancelled",
    "Returned",
    "closed",
  ];

  const rtoStates = [
    "Shipped & Returned",
    "rto-delivered",
    "rto-initiated",
    "RTO lock",
    "RTO In Transit",
    "rto in transit",
  ];

  const cancellableStates = [
    "confirmed",
    "allocated",
    "Allocated",
    "Pick complete",
    "packed",
    "Packed",
    "picked",
    "order placed",
    "pick complete",
    "part allocated",
    "part picked",
  ];

  const activeStates = [
    "Intransit",
    "Out for Delivery",
    "LostInTransit",
    "Shipped complete",
    "OFD lock",
    "Packed",
    "Partially Shipped",
    "Part Allocated",
    "Allocated",
    "confirmed",
    "Pick complete",
    "Part Picked",
  ];

  if (finalStates.includes(status)) {
    return { showDeliveredDate: true, canCancel: false, showEstimate: false };
  }

  if (rtoStates.includes(status)) {
    return {
      showDeliveredDate: true,
      canCancel: false,
      showEstimate: false,
      isReturn: true,
    };
  }

  if (activeStates.includes(status)) {
    const canCancel = cancellableStates.includes(status.toLowerCase());
    return { showDeliveredDate: false, canCancel, showEstimate: true };
  }

  return {
    showDeliveredDate: false,
    canCancel: false,
    showEstimate: false,
    unknown: true,
  };
}

function getDeliveryDate(cust_delivery_date, revised_delivery_date) {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // remove time part

  const customerDate = new Date(cust_delivery_date);
  if (customerDate < today) {
    return revised_delivery_date; // if past, show revised
  } else {
    return moment(cust_delivery_date).format("YYYY-MM-DD"); // else show original
  }
}

// N E W

const cancelledSteps = [
  {
    id: "initiated",
    label: "Refund Initiated",
    icon: <Clock className="w-5 h-5" />,
    completed: false,
    current: false,
  },
  {
    id: "Processed",
    label: "Refund Approved",
    icon: <CheckCircle className="w-5 h-5" />,
    completed: false,
    current: false,
  },
];

const refund_initiated_msg_string = `Delivery canceled due to operational reasons –
refund initiated`;

const refund_initiated_string = "Refund initiated";

const lm_status_track = {
  "SHIPMENT DESTROYED / DISPOSED": refund_initiated_string,
  damage: refund_initiated_string,
  damaged: refund_initiated_string,
  "SHIPMENT DESTROYED / DISPOSED": refund_initiated_string,
  "Shipment Under Investigation": refund_initiated_string,
};

const lm_status_message = {
  "SHIPMENT DESTROYED / DISPOSED": refund_initiated_msg_string,
  damage: refund_initiated_msg_string,
  damaged: refund_initiated_msg_string,
  "SHIPMENT DESTROYED / DISPOSED": refund_initiated_msg_string,
  "Shipment Under Investigation": refund_initiated_msg_string,
  "Mis Route": "Delivery delayed",
  undelivered_due_to_rejection_by_customer: "Delivery Attempted",
  "delivery delayed": "Delivery delayed",
  "Received At Delivery Centre": "Received At Delivery Centre",
  undelivered_due_to_request_for_reschedule:
    "Delivery rescheduled on customer request",
  "Not Delivered": "Undelivered",
  delivered: "Delivered",
  "OTP Based Delivered": "Delivered",
  rto_completed: "RTO Completed",
  "in transit": "In Transit",
  "Shipped complete": "Dispatched",
  confirmed: "Confirmed",
};

const OrderTrackingInfo = () => {
  const [accessToken, setAccessToken] = useState("");
  const navigate = useNavigate();
  const params = useParams();
  const { orderNumber } = params || {};

  const CancelledStatusFlow = [
    {
      status: "initiated",
      label: (
        <>
          <i className="fa-solid fa-rotate mr-2"></i> Refund Initiated
        </>
      ),
    },
    {
      status: "Processed",
      label: (
        <>
          <i className="fa-solid fa-check-circle mr-2"></i> Refund Approved
        </>
      ),
    },
  ];

  const [orderDetail, setOrderDetail] = useState({});
  const [orderNo, setOrderNo] = useState("");
  const order_Status = orderDetail?.order?.order_status || null;
  const lm_Status = orderDetail?.order?.lm_status || null;

  const fetchOrderTrackingData = async (orderNumberToFetch) => {
    if (!orderNumberToFetch) {
      toast.error("Enter a valid order number");
      return;
    }

    const response = await getOrderTrackingData({
      order_number: orderNumberToFetch,
    });
    const { data, status } = response || {};
    console.log("data ---->>>,<<<<<", data);

    if (status === 200 || status === 201) {
      setOrderDetail(data?.data);
      navigate(`/orders/tracking/${orderNumberToFetch}`);
    } else if (status === 404) {
      toast.error(data?.message);
      setOrderNo("");
      navigate(`/orders/tracking`);
    } else {
      toast.error("Something went wrong. Please try again.");
    }
  };

  let decryptedToken = "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";
  async function fetchAndDecryptToken() {
    try {
      const responseurl = await fetch(
        "https://dabur.techtonicretail.com/stellar/api/user/get-shopify-token",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const res = await responseurl.json();
      const encryptedToken = res.data;
      const keyHex =
        "35e18cf13b397730362fdf35d664f97594e4ff83cea983a74587a2a6328332f6";
      const ivHex = "e0ace631b7121dfa1dbe17863fc8856e";

      if (!encryptedToken) {
        console.error("No encrypted token found in the response");
        return;
      }
      decryptedToken = await decryptToken(encryptedToken, keyHex, ivHex);
      setAccessToken(decryptedToken);
    } catch (error) {
      console.error("Error fetching or decrypting token:", error);
    }
  }

  useEffect(() => {
    if (orderNumber) {
      fetchOrderTrackingData(orderNumber);
    }
  }, [orderNumber]);

  useEffect(() => {
    fetchAndDecryptToken();
  }, []);

  const handleButtonClick = () => {
    fetchOrderTrackingData(orderNo);
  };

  const trackingSteps = [
    {
      id: "confirmed",
      label: "Confirmed",
      icon: <CheckCircle className="w-5 h-5" />,
      completed: false,
      current: false,
    },
    {
      id: "allocated",
      label: "Allocated",
      icon: <Package className="w-5 h-5" />,
      completed: false,
      current: false,
    },
    {
      id: "packed",
      label: "Ready To Ship",
      icon: <PackageCheck className="w-5 h-5" />,
      completed: false,
      current: false,
    },
    {
      id: "shipped complete",
      label: "Dispatched",
      icon: <Truck className="w-5 h-5" />,
      completed: false,
      current: false,
    },
    {
      id: "intransit",
      label:
        orderDetail?.order?.order_status === "Intransit" &&
        orderDetail?.order?.lm_status
          ? orderDetail.order?.lm_status?.charAt(0)?.toUpperCase() +
            orderDetail?.order?.lm_status?.slice(1)
          : "In Transit",
      icon: <Clock className="w-5 h-5" />,
      completed: false,
      current: false,
    },
    {
      id: "out for delivery",
      label: "Out For Delivery",
      icon: <Truck className="w-5 h-5" />,
      completed: false,
      current: false,
    },
    {
      id: "delivered",
      label: "Delivered",
      icon: <Home className="w-5 h-5" />,
      completed: false,
      current: false,
    },
  ];

  const statusFlow = [
    {
      status: "confirmed",
      label: (
        <>
          <i className="fa-solid fa-clipboard-check mr-2"></i> Confirmed
        </>
      ),
    },
    {
      status: "allocated",
      label: (
        <>
          <i className="fa-solid fa-clipboard-check mr-2"></i> Allocated
        </>
      ),
    },

    {
      status: "packed",
      label: (
        <>
          <i className="fa-solid fa-clipboard-check mr-2"></i> Ready To Ship
        </>
      ),
    },
    {
      status: "Shipped Complete",
      label: (
        <>
          <i className="fa-solid fa-box-open mr-2"></i> Dispatched
        </>
      ),
    },
    {
      status: "Intransit",
      label: (
        <>
          <i className="fa-solid fa-shipping-fast mr-2"></i>{" "}
          {orderDetail?.order?.order_status === "Intransit" &&
          orderDetail?.order?.lm_status
            ? orderDetail?.order?.lm_status
            : "In Transit"}
        </>
      ),
    },
    {
      status: "out for delivery",
      label: (
        <>
          <i className="fa-solid fa-shipping-fast mr-2"></i> Out For Delivery
        </>
      ),
    },
    {
      status: "delivered",
      label: (
        <>
          <i className="fa-solid fa-house-user mr-2"></i> Delivered
        </>
      ),
    },
  ];

  const getActiveStep = () => {
    const orderStatus = orderDetail?.order?.order_status?.toLowerCase();

    if (orderStatus === "cancelled") {
      return 0;
    }

    if (orderStatus === "pick complete") {
      return statusFlow.findIndex(
        (step) =>
          typeof step.status === "string" &&
          step.status.toLowerCase() === "shipped complete"
      );
    }

    if (orderStatus === "allocated") {
      return statusFlow.findIndex(
        (step) =>
          typeof step.status === "string" &&
          step.status.toLowerCase() === "allocated"
      );
    }

    if (orderStatus === "partially shipped") {
      return statusFlow.findIndex(
        (step) =>
          typeof step.status === "string" &&
          step.status.toLowerCase() === "shipped complete"
      );
    }

    if (orderStatus === "Intransit") {
      return statusFlow.findIndex(
        (step) =>
          typeof step.status === "string" &&
          step.status.toLowerCase() === "Intransit"
      );
    }

    if (orderStatus === "part allocated") {
      // console.log('orderStatus---------- ', orderStatus);
      return statusFlow.findIndex(
        (step) =>
          typeof step.status === "string" &&
          step.status.toLowerCase() === "confirmed"
      );
    }

    if (orderStatus === "allocated") {
      // console.log('orderStatus---------- ', orderStatus);
      return statusFlow.findIndex(
        (step) =>
          typeof step.status === "string" &&
          step.status.toLowerCase() === "confirmed"
      );
    }

    return statusFlow.findIndex(
      (step) =>
        typeof step.status === "string" &&
        step.status.toLowerCase() === orderStatus
    );
  };

  const getCancelActiveStep = () => {
    const refundStatus =
      orderDetail?.refundDetail?.refund_status?.toLowerCase();

    return CancelledStatusFlow.findIndex(
      (step) =>
        typeof step.status === "string" &&
        step.status.toLowerCase() === refundStatus
    );
  };

  const isCancelled =
    orderDetail?.order?.order_status?.toLowerCase() === "cancelled";
  const isRefundExist = orderDetail?.refundDetail ? true : false;
  const [isOpen, setIsOpen] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCancel = () => setIsModalVisible(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const genericApiUrl =
        "https://dabur.techtonicretail.com/stellar/api/user/shopify-generic-call";

      const shopifyDomainOld = "2ebb91-32.myshopify.com";
      const apiVersion = "2024-10";

      const requestedBody = {
        url: `https://${shopifyDomainOld}/admin/api/${apiVersion}/orders/${orderDetail.order.shopify_id}/cancel.json`,
        type: "POST",
        headers: {
          "X-Shopify-Access-Token": accessToken,
          "Content-Type": "application/json",
        },
        data: {
          order: {
            order_id: orderDetail.order.shopify_id,
            status: "Cancelled",
          },
        },
      };

      if (!decryptedToken) {
        message.success("Authorization token missing. Please try again.");
        return;
      }

      try {
        const response = await fetch(genericApiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestedBody),
        });

        if (response.ok) {
          handleCancel();
          fetchOrderTrackingData(orderNumber);
          message.success("Order has been successfully cancelled.");
        } else {
          const errorData = await response.json();
          message.error(
            `Failed to cancel order: ${errorData.errors || "Unknown error"}`
          );
        }
      } catch (error) {
        message.error("An error occurred while canceling the order.");
      }
    } catch (err) {
      message.error("Something went wrong: " + err.message || "");
    } finally {
      setLoading(false);
    }
  };

  // NEW

  const [TrackingSteps, setTrackingSteps] = useState([]);

  useEffect(() => {
    const currentOrderStatus = orderDetail?.order?.order_status?.toLowerCase();
    if (currentOrderStatus && !isCancelled && !isRefundExist) {
      let cloneTrackingSteps = [...trackingSteps];
      const orderTrackingStatus = cloneTrackingSteps.map((item) => item.id);

      if (lm_status_track[lm_Status] === "Refund initiated") {
        cloneTrackingSteps = [
          {
            id: "initiated",
            label: "Refund Initiated",
            icon: <Clock className="w-5 h-5" />,
            completed: true,
            current: true,
          },
          {
            id: "Processed",
            label: "Refund Approved",
            icon: <CheckCircle className="w-5 h-5" />,
            completed: false,
            current: false,
          },
        ];
      } else if (orderTrackingStatus.includes(currentOrderStatus)) {
        for (let index = 0; index < cloneTrackingSteps.length; index++) {
          const element = cloneTrackingSteps[index];
          if (element.id === currentOrderStatus) {
            cloneTrackingSteps[index] = {
              ...cloneTrackingSteps[index],
              completed: true,
              current: true,
            };
            break;
          } else {
            cloneTrackingSteps[index] = {
              ...cloneTrackingSteps[index],
              completed: true,
              current: false,
            };
          }
        }
      }

      setTrackingSteps(cloneTrackingSteps);
    } else {
      if (isRefundExist) {
        const cloneCancelledSteps = [...cancelledSteps];
        for (let index = 0; index < cloneCancelledSteps.length; index++) {
          const element = cloneCancelledSteps[index];
          if (element.id === currentOrderStatus) {
            cloneCancelledSteps[index] = {
              ...cloneCancelledSteps[index],
              completed: true,
              current: true,
            };
            break;
          } else {
            cloneCancelledSteps[index] = {
              ...cloneCancelledSteps[index],
              completed: true,
              current: false,
            };
          }
        }
        setTrackingSteps(cloneCancelledSteps);
      }
    }
  }, [orderNumber, orderDetail]);

  const order_status =
    order_Status === "Intransit" && lm_Status
      ? lm_status_message[lm_Status] || lm_Status
      : lm_status_message[order_Status] || order_Status;

  return (
    <Suspense fallback={<Loader />}>
      {!orderNumber ? (
        <>
          <div className="tracking-page">
            <nav className="bg-white shadow-md fixed w-full top-0 left-0 z-50">
              <div className="container mx-auto flex justify-between items-center px-6 py-3">
                {/* Logo */}
                <a
                  href="https://www.daburshop.com/"
                  className="flex items-center gap-2"
                >
                  <img
                    src="https://www.daburshop.com/cdn/shop/files/Dabur-Logo.wine_1.png?v=1724404379&width=90"
                    alt="Dabur Logo"
                    className="w-12 h-auto"
                  />
                </a>

                {/* Desktop Links */}
                <div className="hidden md:flex items-center gap-6">
                  <a
                    href="/"
                    className="text-gray-700 font-medium hover:text-[#44633f] transition"
                  >
                    Home
                  </a>
                  <a
                    href="/shop"
                    className="text-gray-700 font-medium hover:text-[#44633f] transition"
                  >
                    Shop
                  </a>
                  <a
                    href="https://www.daburshop.com/account"
                    className="text-gray-700 font-medium hover:text-green-600 transition"
                    onClick={() => setIsOpen(false)}
                  >
                    Login
                  </a>
                </div>

                {/* Mobile Menu Button */}
                <button
                  className="md:hidden text-gray-700"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  {isOpen ? (
                    <X className="w-6 h-6" />
                  ) : (
                    <Menu className="w-6 h-6" />
                  )}
                </button>
              </div>

              {/* Mobile Menu */}
              {isOpen && (
                <div className="md:hidden bg-white shadow-md">
                  <div className="flex flex-col items-center gap-4 py-4">
                    <a
                      href="https://www.daburshop.com/"
                      className="text-gray-700 font-medium hover:text-green-600 transition"
                      onClick={() => setIsOpen(false)}
                    >
                      Home
                    </a>
                    <a
                      href="https://www.daburshop.com/"
                      className="text-gray-700 font-medium hover:text-green-600 transition"
                      onClick={() => setIsOpen(false)}
                    >
                      Shop
                    </a>

                    <a
                      href="https://www.daburshop.com/account"
                      className="text-gray-700 font-medium hover:text-green-600 transition"
                      onClick={() => setIsOpen(false)}
                    >
                      Login
                    </a>
                  </div>
                </div>
              )}
            </nav>
            <hr />

            <div className="w-full z-10 flex justify-center items-center py-12 min-h-[70vh] px-4">
              <div className="flex flex-col gap-4 w-full max-w-[400px]">
                <h1 className="text-center text-2xl sm:text-3xl font-bold">
                  Track Your Order
                </h1>

                <input
                  type="text"
                  className="text-black rounded-md p-2 sm:p-3 w-full text-sm sm:text-base border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  onChange={(e) => setOrderNo(e?.target?.value)}
                  placeholder="Enter Order ID (Example: 1001)"
                />

                <button
                  className="px-4 py-2 sm:py-3 tracking-btn rounded-md w-full bg-[#44633f] transition-colors duration-300"
                  onClick={handleButtonClick}
                >
                  Get Tracking Data
                </button>
              </div>
            </div>

            <FooterAdmin />
          </div>
        </>
      ) : (
        <div className="relative">
          <div className="delivertracking-detail">
            <nav className="bg-white shadow-md fixed w-full top-0 left-0 z-50">
              <div className="container mx-auto flex justify-between items-center px-6 py-3">
                {/* Logo */}
                <a
                  href="https://www.daburshop.com/"
                  className="flex items-center gap-2"
                >
                  <img
                    src="https://www.daburshop.com/cdn/shop/files/Dabur-Logo.wine_1.png?v=1724404379&width=90"
                    alt="Dabur Logo"
                    className="w-12 h-auto"
                  />
                </a>

                {/* Desktop Links */}
                <div className="hidden md:flex items-center gap-6">
                  <a
                    href="/"
                    className="text-gray-700 font-medium hover:text-[#44633f] transition"
                  >
                    Home
                  </a>
                  <a
                    href="/shop"
                    className="text-gray-700 font-medium hover:text-[#44633f] transition"
                  >
                    Shop
                  </a>
                  <a
                    href="https://www.daburshop.com/account"
                    className="text-gray-700 font-medium hover:text-green-600 transition"
                    onClick={() => setIsOpen(false)}
                  >
                    Login
                  </a>
                </div>

                {/* Mobile Menu Button */}
                <button
                  className="md:hidden text-gray-700"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  {isOpen ? (
                    <X className="w-6 h-6" />
                  ) : (
                    <Menu className="w-6 h-6" />
                  )}
                </button>
              </div>

              {/* Mobile Menu */}
              {isOpen && (
                <div className="md:hidden bg-white shadow-md">
                  <div className="flex flex-col items-center gap-4 py-4">
                    <a
                      href="https://www.daburshop.com/"
                      className="text-gray-700 font-medium hover:text-green-600 transition"
                      onClick={() => setIsOpen(false)}
                    >
                      Home
                    </a>
                    <a
                      href="https://www.daburshop.com/"
                      className="text-gray-700 font-medium hover:text-green-600 transition"
                      onClick={() => setIsOpen(false)}
                    >
                      Shop
                    </a>

                    <a
                      href="https://www.daburshop.com/account"
                      className="text-gray-700 font-medium hover:text-green-600 transition"
                      onClick={() => setIsOpen(false)}
                    >
                      Login
                    </a>
                  </div>
                </div>
              )}
            </nav>
            <hr className="line-partion mt-14" />
            {/* <div>
              <h3 className="text-center text-[25px] font-bold pt-10 pb-12">
                Your Order Tracking Status
              </h3>
            </div> */}

            {/* Order Info */}
            {/* <div className="flex justify-between items-end px-32">
              <div className="flex flex-col">
                <div className="text-centers">
                  <p className="mt-2 text-[13px]">
                    <i className="fa-solid fa-cart-shopping"></i>{" "}
                    <b>Order No : </b>{" "}
                    <span className="font-bold text-custom-green">
                      #{orderNumber || "#00"}
                    </span>
                  </p>
                </div>
                <div className="text-centers">
                  <p className="mt-2 text-[13px]">
                    <i className="fa-solid fa-truck"></i> <b>Order Status : </b>{" "}
                    <span className="font-bold text-custom-green">
                      {orderDetail?.order?.order_status === "Intransit" &&
                      orderDetail?.order?.lm_status
                        ? orderDetail?.order?.lm_status
                        : orderDetail?.order?.order_status ===
                          "Shipped Complete"
                        ? "Dispatched"
                        : orderDetail?.order?.order_status.toUpperCase()}
                    </span>
                  </p>
                </div>
                {getOrderActions(orderDetail?.order?.order_status)
                  .showEstimate ? (
                  <div className="text-centers">
                    <p className="mt-2 text-[13px]">
                      <i className="fa-solid fa-calendar-days"></i>{" "}
                      <b>Expected Delivery Date : </b>
                      <span className="font-bold text-custom-green">
                        {getDeliveryDate(
                          orderDetail?.order?.cust_delivery_date,
                          orderDetail?.order?.revised_delivery_date
                        )}
                      </span>
                    </p>
                  </div>
                ) : getOrderActions(orderDetail?.order?.order_status)
                    .showDeliveredDate &&
                  orderDetail?.order?.order_status !== "cancelled" ? (
                  <div className="text-centers">
                    <p className="mt-2 text-[13px]">
                      <i className="fa-solid fa-calendar-check"></i>{" "}
                      <b>Delivered Date : </b>
                      <span className="font-bold text-custom-green">
                        {orderDetail?.order?.delivery_date
                          ? moment(orderDetail?.order?.delivery_date).format(
                              "YYYY-MM-DD"
                            )
                          : "--"}
                      </span>
                    </p>
                  </div>
                ) : null}

                {orderDetail?.order?.awb_no && (
                  <div className="text-centers">
                    <p className="mt-2 text-[13px]">
                      <i className="fa-solid fa-barcode"></i> <b>AWB No : </b>
                      <span className="font-bold text-custom-green">
                        {orderDetail?.order?.awb_no}
                      </span>
                    </p>
                  </div>
                )}
                {orderDetail?.order?.lm_partner && (
                  <div className="text-centers">
                    <p className="mt-2 text-[13px]">
                      <i className="fa-solid fa-truck"></i>{" "}
                      <b>Delivery Partner : </b>
                      <span className="font-bold text-custom-green">
                        {orderDetail?.order?.lm_partner}
                      </span>
                    </p>
                  </div>
                )}
              </div>
            </div> */}

            {/* Stepper */}
            {/* <div className="px-4 mx-auto w-full overflow-x-auto pt-12 pb-12 stepper">
              {((isCancelled && isRefundExist) || !isCancelled) && (
                <Stepper
                  steps={(isCancelled && isRefundExist
                    ? CancelledStatusFlow
                    : statusFlow
                  ).map((step) => ({
                    label: (
                      <span className="flex items-center text-[13px]">
                        <i icon={step.icon} className="mr-2 text-green-500" />
                        {step.label}
                      </span>
                    ),
                  }))}
                  activeStep={
                    isCancelled && isRefundExist
                      ? getCancelActiveStep()
                      : getActiveStep()
                  }
                  className="p-0"
                  connectorStateColors={true}
                  connectorStyleConfig={{
                    completedColor: "green",
                    disabledColor: "gray",
                    size: 4,
                    activeColor: "green",
                  }}
                  styleConfig={{
                    activeBgColor: "green",
                    activeTextColor: "green",
                    inactiveTextColor: "gray",
                    inactiveBgColor: "gray",
                    completedTextColor: "green",
                    completedBgColor: "green",
                    circleFontSize: "0px",
                    size: "0.7em",
                    labelFontSize: "12px",
                  }}
                />
              )}
            </div> */}

            {/* N E W */}
            <div className="bg-white py-8 px-4">
              <div className="max-w-4xl mx-auto">
                <div>
                  <h3 className="text-center text-[25px] font-bold pt-10 pb-12">
                    Your Order Tracking Status
                  </h3>
                </div>

                <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 text-sm md:text-base mb-10">
                  <div className="flex items-center space-x-3 p-3 bg-gray-100 rounded-lg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-blue-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5H21m-4 13a2 2 0 11-4 0m-4 0a2 2 0 11-4 0m.8-10H16m.2 12H7.8"
                      />
                    </svg>
                    <div className="flex flex-col">
                      <p className="font-semibold text-gray-700">Order No :</p>
                      <p className="text-gray-500">#{orderNumber || "N/A"}</p>
                    </div>
                  </div>

                  <div className="flex items-center space-x-3 p-3 bg-gray-100 rounded-lg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-green-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0h2m-2 0a2 2 0 01-2-2v-3a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2m0 0h2a2 2 0 002-2v-3a2 2 0 00-2-2m-3-4h6a2 2 0 002-2v-3a2 2 0 00-2-2h-6a2 2 0 00-2 2v3a2 2 0 002 2z"
                      />
                    </svg>
                    <div className="flex flex-col">
                      <p className="font-semibold text-gray-700">
                        Order Status :
                      </p>
                      <p className="text-gray-500">{order_status}</p>
                    </div>
                  </div>

                  {lm_status_track[lm_Status] !== "Refund initiated" &&
                    getOrderActions(orderDetail?.order?.order_status)
                      .showEstimate && (
                      <div className="flex items-center space-x-3 p-3 bg-gray-100 rounded-lg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-purple-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          />
                        </svg>
                        <div className="flex flex-col">
                          <p className="font-semibold text-gray-700">
                            Expected Delivery :
                          </p>
                          <p className="text-gray-500">
                            {getDeliveryDate(
                              orderDetail?.order?.cust_delivery_date,
                              orderDetail?.order?.revised_delivery_date
                            )}
                          </p>
                        </div>
                      </div>
                    )}

                  {orderDetail?.order?.delivery_date &&
                    getOrderActions(orderDetail?.order?.order_status)
                      .showDeliveredDate &&
                    orderDetail?.order?.order_status !== "cancelled" && (
                      <div className="flex items-center space-x-3 p-3 bg-gray-100 rounded-lg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-purple-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          />
                        </svg>
                        <div className="flex flex-col">
                          <p className="font-semibold text-gray-700">
                            Delivered Delivery :
                          </p>
                          <p className="text-gray-500">
                            {orderDetail?.order?.delivery_date
                              ? moment(
                                  orderDetail?.order?.delivery_date
                                ).format("YYYY-MM-DD")
                              : "--"}
                          </p>
                        </div>
                      </div>
                    )}

                  {orderDetail?.order?.awb_no && (
                    <div className="flex items-center space-x-3 p-3 bg-gray-100 rounded-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-gray-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 12h.01M12 7h.01M12 17h.01M17 12h.01M17 7h.01M17 17h.01M7 12h.01M7 7h.01M7 17h.01"
                        />
                      </svg>
                      <div className="flex flex-col">
                        <p className="font-semibold text-gray-700">AWB No :</p>
                        <p className="text-gray-500">
                          {orderDetail?.order?.awb_no}
                        </p>
                      </div>
                    </div>
                  )}

                  {orderDetail?.order?.lm_partner && (
                    <div className="flex items-center space-x-3 p-3 bg-gray-100 rounded-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-indigo-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1m-6-1v1m0-5V9m6 0v1m-6-1v1m0-5V5m6 0v1m-6-1V3m6 0v1"
                        />
                      </svg>
                      <div className="flex flex-col">
                        <p className="font-semibold text-gray-700">
                          Delivery Partner :
                        </p>
                        <p className="text-gray-500">
                          {orderDetail?.order?.lm_partner}
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Main Card */}
                {TrackingSteps.length > 0 && (
                  <div className="bg-[#44633f] rounded-2xl shadow-md border border-green-200 overflow-hidden">
                    {/* Progress Tracker */}
                    <div className="p-8 bg-white">
                      {/* <h2 className="text-2xl bg-white font-bold text-gray-900 mb-8 text-center">
                      Tracking Progress
                    </h2> */}

                      {/* Desktop Progress Bar */}
                      <div className="hidden lg:block relative">
                        <div className="absolute top-6 left-0 right-0 h-1 bg-gray-200 rounded-full mx-12">
                          <div
                            className="h-full bg-gradient-to-r from-[#44633f] to-[#44633f] rounded-full transition-all duration-1000 ease-out"
                            style={{
                              width: `${
                                ((TrackingSteps.filter((step) => step.completed)
                                  .length -
                                  1) /
                                  (TrackingSteps.length - 1)) *
                                100
                              }%`,
                            }}
                          ></div>
                        </div>
                        <div className="flex justify-between items-start">
                          {TrackingSteps.map((step, index) => (
                            <div
                              key={step.id}
                              className="flex flex-col items-center relative"
                            >
                              <div
                                className={`
                      w-12 h-12 rounded-full flex items-center justify-center text-white font-semibold
                      transition-all duration-300 ease-out transform
                      ${
                        step.completed
                          ? step.current
                            ? "bg-gradient-to-r from-[#44633f] to-[#44633f] ring-4 ring-green-600 scale-110"
                            : "bg-gradient-to-r from-[#44633f] to-[#44633f] hover:scale-105"
                          : "bg-gray-300 text-gray-500"
                      }
                    `}
                              >
                                {step.completed ? (
                                  step.icon
                                ) : (
                                  <Circle className="w-5 h-5" />
                                )}
                              </div>
                              <div className="mt-4 text-center">
                                <p
                                  className={`
                        text-sm font-semibold
                        ${step.completed ? "text-gray-900" : "text-gray-500"}
                        ${step.current ? "text-green-600" : ""}
                      `}
                                >
                                  {step.label}
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Mobile Progress List */}
                      <div className="lg:hidden space-y-4">
                        {TrackingSteps.map((step, index) => (
                          <div
                            key={step.id}
                            className="flex items-start space-x-4"
                          >
                            <div
                              className={`
                    w-10 h-10 rounded-full flex items-center justify-center text-white flex-shrink-0
                    ${
                      step.completed
                        ? step.current
                          ? "bg-gradient-to-r from-[#44633f] to-[#44633f]"
                          : "bg-gradient-to-r from-[#44633f] to-[#44633f]"
                        : "bg-gray-300 text-gray-500"
                    }
                  `}
                            >
                              {step.completed ? (
                                step.icon
                              ) : (
                                <Circle className="w-4 h-4" />
                              )}
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center justify-between">
                                <h3
                                  className={`
                        text-base font-semibold
                        ${step.completed ? "text-gray-900" : "text-gray-500"}
                        ${step.current ? "text-[#44633f]" : ""}
                      `}
                                >
                                  {step.label}
                                </h3>
                              </div>
                              {index < trackingSteps.length - 1 && (
                                <div
                                  className={`
                        w-0.5 h-6 ml-4 mt-2
                        ${step.completed ? "bg-[#44633f]" : "bg-gray-200"}
                      `}
                                ></div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <FooterAdmin />
          </div>

          {/* Cancel Order Modal */}
          <Modal
            title={null}
            open={isModalVisible}
            onCancel={handleCancel}
            onOk={handleSubmit}
            confirmLoading={loading}
            okText="Yes, Cancel"
            cancelText="No, Keep Order"
            className="custom-cancel-modal"
          >
            <div className="flex flex-col items-center text-center space-y-4 py-4">
              {/* Warning Icon */}
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-red-100">
                <i className="fa-solid fa-triangle-exclamation text-red-600 text-2xl"></i>
              </div>

              {/* Heading */}
              <h2 className="text-lg font-semibold text-gray-800">
                Confirm Order Cancellation
              </h2>

              {/* Description */}
              <p className="text-sm text-gray-600">
                Are you sure you want to cancel this order?
              </p>
            </div>
          </Modal>
        </div>
      )}
    </Suspense>
  );
};

export default OrderTrackingInfo;
